// src/components/Navbar.js
import React from 'react';
import logo from "./images/logo2.png"
const Navbar = ({ onHowClick ,onHomeClick ,onFaqClick ,onContactClick}) => {
    return (
      <nav className="navbar">
        <div className="logo"><img className='logo' src={logo}></img></div>
        <ul className="nav-links">
        <li><button onClick={onHomeClick}>Ana Sayfa</button></li>
          <li><button onClick={onHowClick}>Nasıl Çalışır?</button></li>
          <li><button onClick={onFaqClick}>SSS</button></li>
          <li><button onClick={onContactClick}>İletişim</button></li>
        </ul>
      </nav>
    );
  };
export default Navbar;